import _ from 'lodash';
import {DateTime} from 'luxon';
import {connect} from 'react-redux';

import {isTeammateNamespace} from '../../../../../libs/shared/core/src/models/helpers/namespaceHelpers';
import {
  createSelector,
  makeMapStateToProps,
  wrapInShallowSelector,
} from '../../../../../srcCommon/helpers/reselectHelpers';
import {channelHasError} from '../../../../helpers/models/channelHelpers';
import {getUserParticipatingChannels} from '../../../../store/data/channels/channelsSelectors';
import {getCompanyPreferences} from '../../../../store/data/company/companySelectors';
import {
  getDismissedChannelErrors,
  getDismissedChannelErrorsNew,
} from '../../../../store/data/localPreferences/localPreferencesSelectors';
import {getIsInboxVisible} from '../../../../store/data/workspace/workspaceSelectors';
import {ChannelErrorBanners} from './channelErrorBanners';

/*
 * Selectors.
 */

const getIsChannelAbuser = createSelector([getCompanyPreferences], (pref) => pref.isChannelAbuser);

const getErrorChannels = wrapInShallowSelector(
  createSelector(
    [
      getUserParticipatingChannels,
      getDismissedChannelErrors,
      getDismissedChannelErrorsNew,
      getIsInboxVisible,
      getIsChannelAbuser,
    ],
    (channels, dismissedChannelErrors, dismissedChannelErrorsNew, isInboxVisible, isChannelAbuser) =>
      _(channels)
        .filter((c) => {
          // We need the channel to have an error.
          if (!channelHasError(c)) {
            return false;
          }

          if (isChannelAbuser) {
            return false;
          }

          const inboxIsVisible = isInboxVisible(c.inboxId);

          // Check for new dismissed dismissed channel error preference
          const dismissedChannelErrorNew = dismissedChannelErrorsNew[c.id];
          if (dismissedChannelErrorNew) {
            // The channel error has been dismissed and the dismissal has not yet expired.
            if (
              dismissedChannelErrorNew.expiryDate &&
              DateTime.fromMillis(dismissedChannelErrorNew.expiryDate) > DateTime.now()
            ) {
              return false;
            }

            // The channel error is for a personal channel and there is no expiration set so we want to reshow the error
            if (isTeammateNamespace(c.namespace) && !dismissedChannelErrorNew.expiryDate) {
              return inboxIsVisible;
            }
          }

          // Check for old fallback dismissed channel error preference
          if (dismissedChannelErrors[c.id]) {
            return false;
          }

          return inboxIsVisible;
        })
        .sortBy((c) => c.id)
        .value(),
  ),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps()(() => ({
  errorChannels: getErrorChannels,
}));

export const ChannelErrorBannersContainer = connect(mapStateToProps)(ChannelErrorBanners);
